import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "dialog" }
const _hoisted_2 = { class: "dialog-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "about" }
const _hoisted_5 = { class: "images" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "image-container" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dialog", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideModal()))
        }, [
          _createVNode(_component_Icon, { icon: "material-symbols-light:close" })
        ]),
        _createElementVNode("img", {
          src: _ctx.currentImage.url
        }, null, 8, _hoisted_3),
        _createElementVNode("p", null, _toDisplayString(_ctx.currentImage.title), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.currentImage.type), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Selected Works", -1)),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "image",
            key: image.url,
            onClick: ($event: any) => (_ctx.showModal(image))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: image.url
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("p", null, _toDisplayString(image.title), 1),
            _createElementVNode("p", null, _toDisplayString(image.type), 1)
          ], 8, _hoisted_6))
        }), 128))
      ])
    ])
  ], 64))
}